(() => {
  if (customElements.get('bh-tabby-payment')) return;

  class BabyhoodTabbyPayment extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      try { this.variants = JSON.parse(this.querySelector('[data-bh-tabby-variants]')?.textContent || '{}'); }
      catch { this.variants = {}; }
      this.currency = this.dataset.currency;
      this.formId = this.dataset.formId;
      this.selectedId = this.dataset.selectedVariant;
      this.dialog = this.querySelector('dialog');
      this.info = this.querySelector('[data-bh-tabby-info]');
      this.querySelector('[data-bh-tabby-help]').href = this.currency === 'SAR' ? 'https://tabby.ai/en-SA/help' : 'https://tabby.ai/en-AE/help';

      document.addEventListener('variant:change', event => {
        // A form's named input "id" can shadow form.id in Prestige's event data.
        if (event.detail?.formId !== this.formId && event.target?.getAttribute?.('id') !== this.formId) return;
        this.selectedId = String(event.detail.variant?.id || '');
        this.update();
      }, { signal });
      document.addEventListener('change', event => {
        if (!this.belongsToForm(event.target)) return;
        if (event.target.name === 'id') this.selectedId = event.target.value;
        if (event.target.name === 'id' || event.target.name === 'quantity') this.update();
      }, { signal });
      document.addEventListener('input', event => {
        if (event.target.name === 'quantity' && this.belongsToForm(event.target)) this.update();
      }, { signal });
      this.info.addEventListener('click', () => this.openInfo(), { signal });
      this.querySelector('[data-bh-tabby-close]').addEventListener('click', () => this.dialog.close(), { signal });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      }, { signal });
      this.dialog.addEventListener('close', () => this.info.focus({ preventScroll: true }), { signal });
      this.update();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }

    belongsToForm(element) {
      return element instanceof HTMLElement && (element.form?.getAttribute('id') === this.formId || element.getAttribute('form') === this.formId);
    }

    update() {
      const form = document.getElementById(this.formId);
      const idInput = form?.elements.namedItem('id');
      if (idInput?.value) this.selectedId = String(idInput.value);
      const variant = this.variants[this.selectedId];
      this.hidden = !['AED', 'SAR'].includes(this.currency) || !variant?.available || !Number.isFinite(variant.price) || variant.price <= 0;
      if (this.hidden) {
        if (this.dialog.open) this.dialog.close();
        return;
      }
      const amount = variant.price / 400;
      this.querySelector('[data-bh-tabby-amount]').textContent = `${this.currency} ${new Intl.NumberFormat('en-AE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount)}`;
      const quantity = Math.max(1, Number.parseInt(form?.elements.namedItem('quantity')?.value, 10) || 1);
      this.querySelector('[data-bh-tabby-basis]').textContent = quantity > 1 ? `Estimate per item (${quantity} items selected).` : 'Estimate per item.';
      this.dataset.currentVariant = this.selectedId;
      this.dataset.itemPrice = String(variant.price);
      this.dataset.quantity = String(quantity);
    }

    openInfo() {
      // Use the existing app's current merchant offer and popup, without reading,
      // copying or hard-coding its credentials or altering payment processing.
      const roots = [this.querySelector('[data-bh-tabby-native]')];
      for (let index = 0; index < roots.length; index += 1) {
        const root = roots[index];
        if (!root) continue;
        const link = root.querySelector('[class*="SnippetContent__Link"]');
        if (link) {
          link.click();
          return;
        }
        root.querySelectorAll('*').forEach(element => {
          if (element.shadowRoot) roots.push(element.shadowRoot);
        });
      }
      if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
      else this.dialog.setAttribute('open', '');
    }
  }
  customElements.define('bh-tabby-payment', BabyhoodTabbyPayment);
})();
